import React from "react";
// @ts-ignore
import { CustomArrowProps } from "react-slick";
import nextArrowImg from '../../Assets/icon/icon_arrow-right.svg'; // Asegúrate de que la ruta sea correcta
 // Asegúrate de que la ruta sea correcta
import prevArrowImg from '../../Assets/icon/icon_arrow-left.svg'; // Asegúrate de que la ruta sea correcta


export const NextArrow = ({ className, style, onClick }) => (
    <div
        className={className}
        style={{
            ...style,
            display: "flex",
            alignItems: "center", // Alinea el contenido verticalmente
            justifyContent: "center", // Centra el contenido

            backgroundSize: 'cover'
        }}
        onClick={onClick}
    >
        <img src={nextArrowImg} alt="Next"/>
    </div>
);

export const PrevArrow = ({className, style, onClick}) => (
    <div
        className={className}
        style={{
            ...style,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundSize: 'cover'
        }}
        onClick={onClick}
    >
        <img src={prevArrowImg} alt="Previous"/>
    </div>
);
